import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Utils
import { Table, kaReducer } from 'ka-table';
import { SortDirection, SortingMode } from 'ka-table/enums';
import { updateData } from 'ka-table/actionCreators';

// Icons
import { ReactComponent as ChevronUp } from '../../../assets/icons/chevron_up.svg';
import { ReactComponent as ChevronDown } from '../../../assets/icons/chevron_down.svg';

function GenericTable({ columns, rows }) {
  const [tableProps, changeTableProps] = useState({
    columns,
    data: rows,
    rowKeyField: 'id',
    sortingMode: SortingMode.Single,
  });

  const dispatch = (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
  };

  useEffect(() => {
    dispatch(updateData(rows));
  }, [rows]);

  const getCell = (rowData, field, bold) => {
    if (bold) return <strong className="c-neutral-01 fw-600">{rowData[field]}</strong>;
    return rowData[field];
  };

  const getSortIcon = (column) => {
    const up = <ChevronUp width={15} height={15} />;
    const down = <ChevronDown width={15} height={15} />;
    return column.sortDirection === SortDirection.Ascend ? up : down;
  };

  return (
    <div>
      <Table
        {...tableProps}
        dispatch={dispatch}
        childComponents={{
          cellText: {
            content: ({ rowData, field, column }) => getCell(rowData, field, column.bold),
            elementAttributes: ({ column }) => ({
              'data-column': column.title,
            }),
          },
          sortIcon: {
            content: ({ column }) => getSortIcon(column),
          },
        }}
      />
    </div>
  );
}

GenericTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
  })),
  rows: PropTypes.arrayOf(PropTypes.shape({})),
};

GenericTable.defaultProps = {
  columns: [],
  rows: [],
};

export default GenericTable;
